/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")


  
    
export interface API18198Item {
  
  /**  */
  userId?: string;
  
  /**  */
  userName?: string;
  
  /**  */
  userPhone?: string;
  
  /**  */
  remark?: string;
  
  /**  */
  userEmail?: string;
  
  /** 钉钉id */
  dingdingUserId?: string;
  
  /** 部门全称 */
  orgFullName?: string;
  
};
    
  



export interface API18198Req {
  
  /** 花名 */
  userName?: string;
    
  /** 手机号 */
  userPhone?: string;
    
  /** 状态 */
  status?: string;
    
  /** 是否非钉钉用户 */
  isOut?: string;
    
  /** 部门id */
  orgId?: string;
    
};



export interface API18198Res {
  /** T  */
  records?: API18198Item[];
  
};


// 18198 用户列表（新）

export interface IUseGetAPI18198Return {
  /** 用户列表（新）: 接口请求状态 */
  isAPI18198Loading: boolean;
  /** 用户列表（新）: 接口请求返回数据 */
  dataAPI18198: API18198Res;
  /**  用户列表（新）: 接口数据请求方法 */
  fetchAPI18198Data:  (inputs: API18198Req, config?: YWRequestConfig) => Promise<API18198Res>;
  /** 用户列表（新）: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI18198 = ():IUseGetAPI18198Return => {
  let isMount = true;
  const [isAPI18198Loading, setIsAPI18198Loading] = useState(false);
  const [dataAPI18198, setDataAPI18198] = useState<API18198Res>({} as API18198Res);
  const requestUrl = `${basePath}/ywwl-admin/user/list`;

  const fetchAPI18198Data = async (inputs: API18198Req, config?: YWRequestConfig): Promise<API18198Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API18198Req>) || {}) as API18198Req;
    
  
    if ( isMount ) {
      setIsAPI18198Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API18198Res>(`${basePath}/ywwl-admin/user/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI18198(res || {} as API18198Res);
        setIsAPI18198Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI18198Loading(false);
      }
      return false as unknown as API18198Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI18198Loading,
    dataAPI18198,
    fetchAPI18198Data,
    requestUrl,
  }
}

